import React, { useEffect, useState } from 'react'
import { Prompt, useHistory } from 'react-router-dom'
import { Form as FormikForm, connect } from 'formik'
import { flattenObject } from 'services/Utilities'
import { useDispatch } from 'react-redux'

import { closeModal } from 'store/actions/modals'
import { Button } from 'components/Forms'
import { Button as MerinioButton } from 'ui'
import { t } from 'translations'

const Form = ({ children, dirty, leavingAction, inModal, locationToGo, noPrompt }) => {
  const dispatch = useDispatch()
  const [leavePage, setLeaving] = useState()
  const { goBack, push } = useHistory()

  // Trigger the departure with history (it will bring you to the previous page or a specific page), also unset leavePage to prevent a infinit loop
  useEffect(() => {
    if (leavePage) {
      if (locationToGo) push(locationToGo)
      else if (leavingAction) leavingAction()
      else goBack()
      setLeaving()
    }
  }, [goBack, leavingAction, leavePage, locationToGo, push])

  // Cancel button
  const leavingButton = inModal ? (
    <Button text="actions.CLOSE" className="btn btn-outline-secondary ml-2" onClick={() => dispatch(closeModal())} />
  ) : (
    <MerinioButton type="button" color="secondary" className="ml-2" onClick={() => setLeaving(true)} outlined>
      {t('CANCEL')}
    </MerinioButton>
  )

  return (
    <>
      <FormikForm>
        {/* Children is a function to be able to inject into it the leave button (also works like the other form component) */}
        {typeof children === 'function' ? children({ leavingButton }) : children}
        {!noPrompt ? <Prompt when={dirty} message={t('employee.attendanceForm.QUIT_PAGE')} /> : null}
      </FormikForm>
      <ErrorFocus />
    </>
  )
}

const ErrorFocus = connect(props => {
  const { isSubmitting, isValidating, errors } = props.formik

  useEffect(() => {
    const keys = Object.keys(flattenObject(errors))

    if (keys.length > 0 && isSubmitting && !isValidating) {
      const selector = `[data-error-key="${keys[0]}"]`
      const fallbackSelector = `[name="${keys[0]}"]`
      const errorElement = document.querySelector(selector) || document.querySelector(fallbackSelector)

      if (errorElement) {
        errorElement.scrollIntoView()
      }
    }
  }, [errors, isSubmitting, isValidating])

  return null
})

export default Form
